import { Pipe, PipeTransform } from '@angular/core';
import { ConsolidatedTask } from '../models/task';

@Pipe({
  name: 'taskNavigationUrl'
})
export class TaskNavigationUrlPipe implements PipeTransform {
  transform(task: ConsolidatedTask.Model): string[] {
    switch (task.entityType) {
      case ConsolidatedTask.EntityType.Company:
        return ['/Contacts', 'Company', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Individual:
        return ['/Contacts', 'Individual', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Trust:
        return ['/Contacts', 'Trust', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Lead:
        return ['/Leads', task.entityId];
      default:
        return ['/Opportunities', task.entityId, 'Tasks'];
    }
  }
}
